import Cookies from "js-cookie";

window.addEventListener("DOMContentLoaded", (event) => {
    const header = document.querySelector('#vue-header')
    if (header === null) {
        return;
    }
    const modal = document.querySelector('.js-promo-modal')

    if(modal){
        const closeBtns = [...document.querySelectorAll('.js-close-promo-modal')]      
        
        const closeModal = () => {
            Cookies.set('promo', true, { expires: 30 })
            modal.classList.add('hidden')
        }
        
        closeBtns.forEach(button => {
            button.addEventListener('click', (event) => {
                closeModal()
            })
        })
    
        if (!Cookies.get('promo')) {
            setTimeout(function(){
                Cookies.set('promo', true, { expires: 30 })
                if (modal) {
                    modal.classList.remove('hidden')         
                }
            }, 3000 );
        }
    }
})